<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="28"></FHeader>
		<FOtherBanner :name1="'加入我们'" :name2="'Join Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">加入我们</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:40px;">
				<div style="height:65px;">
					<div style="float:left;width:250px;">
						<div style="font-size: 24px;font-weight: 900;border-bottom: 3px solid;padding-bottom: 15px;width: 100px;color:#333333;">
							社会招聘
						</div>
						<div style="height: 1px;width: 100%;border-top: 1px solid #AAAAAA;"></div>
					</div>
					<div style="float: right;width: calc(100% - 250px);text-align: right;font-size: 14px;color: #333333;">
						<span>地区：</span>
						<span @click="changeAddress('')" :style="{color:!address || address == ''?'#98273A':'#333333',padding:'0 10px',cursor:'pointer'}">全部</span>
						<span @click="changeAddress(item)" :style="{color:address == item?'#98273A':'#333333',padding:'0 10px',cursor:'pointer'}" v-for="item in addressList" :key="item">{{item}}</span>
					</div>
				</div>
				<div :style="{'padding-top':'0px','height':tableList.length>6?'1260px':(tableList.length>3?'865px':'495px')}">
					<div :style="{float:'left',width:'30%','margin-right':index!=2&&index!=5&&index!=8?'calc(5% - 4px)':'0%',height:'370px','margin-top':'25px','border':'1px solid #D7D7D7'}" v-for="(item,index) in tableList" :key="index">
						<div style="color: #8B8D8B;font-size: 18px;font-weight: 900;padding: 50px 25px 0 25px;cursor: pointer;" @click="toDetail(item,index)">{{item.name}}</div>
						<div style="margin-left: 25px;height: 3px;width: 35px;background-color: #98273A;margin-top: 15px;"></div>
						<div style="margin-left: 25px;margin-right: 25px;height: 1px;background-color: #AAAAAA;"></div>
						<div style="margin-top:30px;margin-left: 25px;margin-right: 25px;">
							<div>
								<div style="float: left;width: 60px;height: 115px;font-size: 14px;font-weight: 900;color: #666666;">岗位介绍</div>
								<div style="float: left;padding-left: 10px;height: 115px;width: calc(100% - 70px);color: #666666;font-size: 14px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical">{{item.content}}</div>
							</div>
							<div style="padding-top: 130px;">
								<div style="float: left;width: 60px;height: 30px;font-size: 14px;font-weight: 900;color: #666666;">工作地点</div>
								<div style="float: left;padding-left: 10px;height: 30px;width: calc(100% - 70px);color: #666666;font-size: 14px;">{{item.address}}</div>
							</div>
							<div style="padding-top: 30px;">
								<div style="float: left;width: 60px;height: 30px;font-size: 14px;font-weight: 900;color: #666666;">招聘人数</div>
								<div style="float: left;padding-left: 10px;height: 30px;width: calc(100% - 70px);color: #666666;font-size: 14px;">{{item.number}}人</div></div>
							<div @click="toDetail(item)" style="float: left;margin-top: 5px;font-size: 14px;text-align: center;width: 70px;padding: 7px 25px;color: #98273A;border: 1px solid #98273A;border-radius: 50px;cursor: pointer;">
								了解详情
							</div>
						</div>
						<!-- <div style="color: #595959;font-size: 14px;margin-left: 25px;margin-right: 25px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 4;line-height: 24px;-webkit-box-orient: vertical;margin-bottom: 20px;">{{item.content}}</div>
						<div style="font-size: 14px;border-top: 1px solid #D7D7D7;margin-right: 25px;margin-left: 25px;font-weight: 900;color: #AAAAAA;padding-top: 20px;">
							<div style="float: left;">{{item.publish.substring(0,10)}}</div>
							<img  @click="toRedDetail(item,index)" style="float: right;transform: rotate(-90deg);" src="../../assets/fImage/xiangyoujiantou.svg">
						</div> -->
					</div>
				</div>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:page-size="9"
					:total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {query} from "@/api/joinUs";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
				address:'',
				addressList:[]
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			changeAddress(address){
				this.address = address
				this.pageNo = 1;
				this.list()
			},
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/joinUsDetail',
						query:{
							item:JSON.stringify(item),
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					name: '',
					address:this.address,
					type:'社会招聘',
					page: this.pageNo,
					pageSize: 9,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					this.addressList = data.data.addressList
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">
	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
